var wxLite = require('./wx_lite');

module.exports = wxLite;
